import { fetchData } from '../../services/apiClient';
import { API_ENDPOINTS } from '../../services/ApiConfig';

export interface PackData {
  segment: string;
  pack_size: string;
  volume_uc: number;
  volume_uc_growth: number;
  volume_pc: number;
  volume_pc_growth: number;
  transaction: number;
  transaction_growth: number;
  market_share: number;
  net_revenue: number;
  net_revenue_growth: number;
  nr_by_uc: number;
  nr_by_uc_growth: number;
  can_sour: number;
}

export interface SegmentDeepDiveResponse {
  segment: string;
  volume_uc: number;
  volume_uc_growth: number;
  volume_pc: number;
  volume_pc_growth: number;
  transaction: number;
  transaction_growth: number;
  market_share: number;
  net_revenue: number;
  net_revenue_growth: number;
  nr_by_uc: number;
  nr_by_uc_growth: number;
  can_sour: number;
  pack: PackData[];
}

export const fetchOutputRGMSegmentDeepDive = async (payload: any) => {
  return fetchData<SegmentDeepDiveResponse[]>(API_ENDPOINTS.SCENARIO_OUTPUT.SEGMENT_PACK_DEEPDIVE_FOR_RGM, payload);
};

export const fetchOutputFinanceSegmentDeepDive = async (payload: any) => {
  return fetchData<SegmentDeepDiveResponse[]>(API_ENDPOINTS.SCENARIO_OUTPUT.SEGMENT_PACK_DEEPDIVE_FOR_FINANCE, payload);
};

export const fetchAllScenarios = async (): Promise<string[]> => {
  return fetchData<string[]>(API_ENDPOINTS.SCENARIO_OUTPUT.FETCH_ALL_SCENARIOS, {});
};

export const fetchAllOutputBrands = async (payload: any): Promise<{ brand: string[] }> => {
  return fetchData(API_ENDPOINTS.SCENARIO_OUTPUT.FETCH_ALL_OUTPUT_BRANDS, payload);
};

export const fetchDeepDiveDownloadDataAPI = async (payload: any): Promise<{ brand: string[] }> => {
  return fetchData(API_ENDPOINTS.SCENARIO_OUTPUT.DEEPDIVE_DOWNLOAD, payload);
};
